function resizeTextarea(el) {
  if (!el || el.tagName !== 'TEXTAREA') return;

  el.style.height = 'auto';
  const minHeight = typeof el.__autogrowMinHeight === 'number' ? el.__autogrowMinHeight : 0;
  const nextHeight = Math.max(el.scrollHeight, minHeight);
  el.style.height = `${nextHeight}px`;
}

function updateMinHeight(el) {
  if (!el || el.tagName !== 'TEXTAREA') return;
  const computedMinHeight = parseFloat(getComputedStyle(el).minHeight);
  el.__autogrowMinHeight = Number.isFinite(computedMinHeight) ? computedMinHeight : 0;
}

export default {
  mounted(el) {
    if (el.tagName !== 'TEXTAREA') return;

    el.style.overflow = 'hidden';
    el.style.resize = 'none';
    updateMinHeight(el);

    const onInput = () => resizeTextarea(el);
    el.__autogrowOnInput = onInput;
    el.addEventListener('input', onInput);

    const onResize = () => {
      updateMinHeight(el);
      resizeTextarea(el);
    };
    el.__autogrowOnResize = onResize;
    window.addEventListener('resize', onResize, { passive: true });

    requestAnimationFrame(() => resizeTextarea(el));
  },
  updated(el) {
    updateMinHeight(el);
    resizeTextarea(el);
  },
  unmounted(el) {
    if (el.__autogrowOnInput) {
      el.removeEventListener('input', el.__autogrowOnInput);
      delete el.__autogrowOnInput;
    }
    if (el.__autogrowOnResize) {
      window.removeEventListener('resize', el.__autogrowOnResize);
      delete el.__autogrowOnResize;
    }
    if (Object.prototype.hasOwnProperty.call(el, '__autogrowMinHeight')) {
      delete el.__autogrowMinHeight;
    }
  },
};
